export const cleanHostname = value => {
  const url = new URL(value);
  return url.hostname;
};
